import style from "./AppLayout.module.css";
import Header from "@/ui/header/Header";
import EnglishHintBar from "@/ui/englishHintBar/EnglishHintBar";
import { Outlet } from "react-router-dom";
import Footer from "@/layouts/footer/Footer";

// `footer` is opt-out rather than opt-in: all but a couple of pages want it,
// and a route that forgets to ask should still get the site's own chrome.
function AppLayout({ footer = true }) {
	return (
		<div className={style.page}>
			{/* Here rather than in App: this layout sits inside UmamiWrapper, so
			    switching language from the bar is tracked, and the auth pages
			    and the player stay free of it. */}
			<EnglishHintBar />
			<Header />
			{/* The gap between a page and the footer belongs here, not to each
			    page. Left to themselves they landed on 4em, 6em, 3em, or
			    nothing at all — and the pages with nothing butted the footer's
			    tinted block straight against their last element. */}
			<main className={style.main}>
				<Outlet />
			</main>
			{footer && <Footer />}
		</div>
	);
}

export default AppLayout;
